import type React from "react";
import { ReactComponent as Svg } from "./assets/tick-circle.svg";
import * as styles from "./Icon.module.scss";

type TickCircleProps = React.SVGProps<SVGSVGElement>;

export const TickCircle = ({ className, ...props }: TickCircleProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
